module.exports = __webpack_public_path__ + "static/media/font.887fbfb4.svg";